<template>
  <div class="permissions-tree-wrapper">
    <!-- Contenedor del árbol -->
    <div class="permissions-tree border rounded p-2 bg-white" style="max-height: 380px; overflow-y: auto; overflow-x: hidden;">
      <div
        v-if="!arbolPermisos || !arbolPermisos.length"
        class="text-muted small text-center py-4"
      >
        <i class="bi bi-info-circle mr-1"></i> No se encontraron permisos para el rol seleccionado.
      </div>

      <div
        v-for="app in arbolPermisos"
        :key="'app_' + app.nombre"
        class="tree-app-node mb-2"
      >
        <!-- Nivel 1: Aplicación -->
        <div
          class="d-flex align-items-center justify-content-between p-2 rounded bg-light border tree-header-app"
          @click="toggleNode('app_' + app.nombre)"
        >
          <div class="d-flex align-items-center">
            <button
              type="button"
              class="btn btn-link btn-sm text-secondary p-0 mr-2"
              @click.stop="toggleNode('app_' + app.nombre)"
            >
              <i
                class="bi"
                :class="isNodeExpanded('app_' + app.nombre) ? 'bi-chevron-down' : 'bi-chevron-right'"
              ></i>
            </button>

            <span class="font-weight-bold text-dark">
              <i class="bi bi-layers-fill text-primary mr-1"></i>
              {{ getAppNombre(app.nombre) }}
            </span>
          </div>

          <div class="d-flex align-items-center">
            <span
              class="badge badge-pill"
              :class="getAppSelectedCount(app) > 0 ? 'badge-primary' : 'badge-light text-muted border'"
            >
              {{ getAppSelectedCount(app) }} / {{ app.permisos.length }}
            </span>
          </div>
        </div>

        <!-- Nivel 2: Permisos dentro de la Aplicación -->
        <div
          v-show="isNodeExpanded('app_' + app.nombre)"
          class="tree-children-app pl-4 pr-2 py-1"
        >
          <div
            v-for="permiso in app.permisos"
            :key="'perm_' + app.nombre + '_' + permiso.nombre"
            class="tree-permiso-leaf d-flex align-items-center justify-content-between py-1"
          >
            <div v-if="!disabled" class="custom-control custom-checkbox mr-2 flex-grow-1">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="'perm_' + app.nombre + '_' + permiso.nombre"
                :value="permiso.nombre"
                :checked="isPermisoSeleccionado(permiso.nombre)"
                @change="togglePermiso(permiso.nombre)"
              />
              <label
                class="custom-control-label small"
                :for="'perm_' + app.nombre + '_' + permiso.nombre"
              >
                <span class="font-weight-bold">{{ permiso.descripcion || permiso.nombre }}</span>
                <span class="text-muted ml-1" style="font-size: 0.75rem;">({{ permiso.nombre }})</span>
              </label>
            </div>
            <div v-else class="d-flex align-items-center small flex-grow-1">
              <i
                class="bi mr-2"
                :class="isPermisoSeleccionado(permiso.nombre) ? 'bi-check-square-fill text-success' : 'bi-square text-muted'"
              ></i>
              <span class="font-weight-bold">{{ permiso.descripcion || permiso.nombre }}</span>
              <span class="text-muted ml-1" style="font-size: 0.75rem;">({{ permiso.nombre }})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UsuarioPermisosTree",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    arbolPermisos: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nodosExpandidos: {},
    };
  },
  watch: {
    arbolPermisos: {
      immediate: true,
      handler(newArbol) {
        if (Array.isArray(newArbol)) {
          newArbol.forEach((app) => {
            if (this.nodosExpandidos["app_" + app.nombre] === undefined) {
              this.$set(this.nodosExpandidos, "app_" + app.nombre, true);
            }
          });
        }
      },
    },
  },
  methods: {
    getAppNombre(nombre) {
      if (!nombre) return "";
      const name = String(nombre).toUpperCase() === "GENESIS"
        ? (process.env.VUE_APP_NAME || nombre)
        : nombre;
      return String(name).toUpperCase();
    },

    isPermisoSeleccionado(nombre) {
      return Array.isArray(this.value) && this.value.includes(nombre);
    },

    getAppSelectedCount(app) {
      if (!app || !app.permisos || !Array.isArray(this.value)) return 0;
      return app.permisos.filter((p) => this.value.includes(p.nombre)).length;
    },

    isNodeExpanded(nodeKey) {
      return this.nodosExpandidos[nodeKey] !== false;
    },

    toggleNode(nodeKey) {
      this.$set(this.nodosExpandidos, nodeKey, !this.isNodeExpanded(nodeKey));
    },

    togglePermiso(nombre) {
      const current = Array.isArray(this.value) ? [...this.value] : [];
      const idx = current.indexOf(nombre);
      if (idx > -1) {
        current.splice(idx, 1);
      } else {
        current.push(nombre);
      }
      this.$emit("input", current);
    },
  },
};
</script>

<style scoped>
.permissions-tree {
  font-size: 0.9rem;
}
.tree-header-app {
  background-color: #f8f9fa;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease-in-out;
}
.tree-header-app:hover {
  background-color: #e9ecef;
}
.tree-permiso-leaf {
  transition: background-color 0.12s ease-in-out;
  border-bottom: 1px dashed #eef0f2;
}
.tree-permiso-leaf:hover {
  background-color: #f8f9fa;
}
.custom-checkbox .custom-control-label {
  cursor: pointer;
}
.btn-xs {
  font-size: 0.75rem;
}
</style>
